
import Pagination from './Pagination';
import { formatDate } from '../service/utils/formatters';
import TableSkeleton from '../admin/TableSkeleton';

const ValidationTable = ({ 
  validations, 
  onSelectValidation, 
  currentPage, 
  totalPages, 
  totalCount,
  onPageChange,
  loading = false
}) => {
  const getStatusBadge = (status) => {
    const statusConfig = {
      Pending: { class: 'warning', label: 'En Attente', icon: 'fas fa-hourglass-split' },
      Approved: { class: 'success', label: 'Approuvé', icon: 'fas fa-check-circle' },
      Rejected: { class: 'danger', label: 'Rejeté', icon: 'fas fa-x-circle' },
      Cancelled: { class: 'secondary', label: 'Annulé', icon: 'fas fa-slash-circle' }
    };

    const config = statusConfig[status] || statusConfig.Pending;

    return (
      <span className={`badge bg-${config.class} bg-opacity-10 text-${config.class} border border-${config.class} border-opacity-25`}>
        <i className={`${config.icon} me-1`}></i>
        {config.label}
      </span>
    );
  };

  const getEntityIcon = (entityName) => {
    const icons = {
      Order: 'fa fa-cart',
      Account: 'fa fa-person',
      Transaction: 'fas fa-arrow-left-right'
    };
    return icons[entityName] || 'fas fa-file-text';
  };

  const getEntityLabel = (entityName) => {
    const labels = {
      Order: 'Ordre',
      Account: 'Compte',
      Transaction: 'Transaction'
    };
    return labels[entityName] || entityName;
  };


  if (loading) {
    return (
      <div className="card">
        <div className="card-body text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Chargement...</span>
          </div>
          <p className="mt-2 text-muted">Chargement des validations...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-header">
            <h4 className="fw-bold text-primary fs-4 text-uppercase m-0">
              <i className="bi bi-list-task me-2"></i>
              Liste des Tâches ({totalCount})
            </h4>
          </div>

          <div className="card-body">
            {loading ? (
              // Utilisation du Skeleton réutilisable avec les colonnes spécifiques à ton tableau
              <TableSkeleton columns={5} rows={10} />
            ) : validations.length > 0 ? (
              <>
                <div className="table-responsive">
                  <table className="table table-striped table-hover">
                    <thead className='table-light'>
                      <tr>
                        {/* <th>ID Validation</th> */}
                        <th>Type de validation</th>
                        <th>Référence</th>
                        <th>Demandeur</th>
                        <th>Date Soumission</th>
                        <th>Statut</th>
                        <th className="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {validations.map((validation) => (
                        <tr key={validation.validationId}>
                          {/* <td className="fw-semibold text-primary">
                            #{validation.validationId}
                          </td> */}
                          <td>
                            <span className="badge bg-light text-dark">
                              <i className={`${getEntityIcon(validation.entityName)} me-1`}></i>
                              {getEntityLabel(validation.entityName)}
                            </span>
                          </td>
                          <td>
                            {validation.orderReference ? (
                              <span className="fw-semibold">
                                {validation.orderReference}
                              </span>
                            ) : (
                              <span className="text-muted">#{validation.entityId}</span>
                            )}
                          </td>
                          <td>{validation.createdByUserName || 'Inconnu'}</td>
                          <td>
                            <small className="text-muted">
                              {formatDate(validation.createdUtc)}
                            </small>
                          </td>
                          <td>{getStatusBadge(validation.status)}</td>
                          <td className="text-center">
                            <button
                              className="btn btn-sm btn-outline-primary me-1"
                              onClick={() => onSelectValidation(validation)}
                              title="Voir les détails"
                            >
                              <i className="fa fa-eye"></i>
                            </button>
                            {validation.status === 'Pending' && (
                              <>
                                <button
                                  className="btn btn-sm btn-outline-success me-1"
                                  onClick={() => onSelectValidation({ ...validation, action: 'approve' })}
                                  title="Approuver"
                                >
                                  <i className="fa fa-check"></i>
                                </button>
                                <button
                                  className="btn btn-sm btn-outline-danger"
                                  onClick={() => onSelectValidation({ ...validation, action: 'reject' })}
                                  title="Rejeter"
                                >
                                  <i className="fa fa-x"></i>
                                </button>
                              </>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination SERVEUR */}
                {totalPages > 1 && (
                  <div className="mt-3">
                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      totalCount={totalCount}
                      onPageChange={onPageChange}
                    />
                  </div>
                )}
              </>
            ) : (
              <div className="text-center text-muted py-5">
                <h5>Aucune tâche de validation</h5>
                <p className="mb-0">Aucune tâche ne correspond à vos critères de recherche.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValidationTable;